export default {
    namespaced: true,
    state: () => ({
        showBalance: true
    }),
    mutations: {
      TOGGLE_SHOW_BALANCE(state) {
        state.showBalance = !state.showBalance
      },
      SET_SHOW_BALANCE(state, value) {
        state.showBalance = value
      }
    },
    getters: {
        showBalance: state => state.showBalance
    }
  }